// Article series announced in the pinned-series menu before they have content.
export const comingSoonQCodes: { qCode: string; name: string }[] = [
  {
    qCode: 'mni-section:d-north-america-natural-gas-weekly',
    name: 'North America Natural Gas Weekly',
  },
  { qCode: 'mni-section:d-north-america-liquids-weekly', name: 'North America Liquids Weekly' },
];
